module.exports = __webpack_public_path__ + "img/isPr_is1024_lost.3c4424d8.png";